import { render, staticRenderFns } from "./tranferNew.vue?vue&type=template&id=1c129288&scoped=true"
import script from "./tranferNew.vue?vue&type=script&lang=js"
export * from "./tranferNew.vue?vue&type=script&lang=js"
import style0 from "./tranferNew.vue?vue&type=style&index=0&id=1c129288&prod&lang=scss&scoped=true"
import style1 from "./tranferNew.vue?vue&type=style&index=1&id=1c129288&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c129288",
  null
  
)

export default component.exports